module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "xxgs"
    }
  }, [_c('header', {
    staticClass: "am-topbar"
  }, [_c('OffCanvas', {
    staticClass: "meun"
  }, [_vm._v("边侧栏")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_vm._l((_vm.xxgstitle), function(item, key, index) {
    return (_vm.IsFirstTab === Math.floor(index / 4)) ? _c('router-link', {
      key: key,
      class: {
        active: _vm.$route.params.nr === key
      },
      attrs: {
        "to": {
          name: 'xxgs',
          params: {
            nr: key
          }
        }
      }
    }, [_vm._v(_vm._s(item) + "\n    ")]) : _vm._e()
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showOthers),
      expression: "!showOthers"
    }],
    staticClass: "icon",
    on: {
      "click": function($event) {
        _vm.showOthers = true
      }
    }
  }, [_c('i', {
    staticClass: "am-icon-chevron-down"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOthers),
      expression: "showOthers"
    }],
    staticClass: "icon",
    on: {
      "click": function($event) {
        _vm.showOthers = false
      }
    }
  }, [_c('i', {
    staticClass: "am-icon-chevron-up"
  })])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOthers),
      expression: "showOthers"
    }],
    staticClass: "tab"
  }, _vm._l((_vm.xxgstitle), function(item, key, index) {
    return (_vm.IsFirstTab !== Math.floor(index / 4)) ? _c('router-link', {
      key: key,
      attrs: {
        "to": {
          name: 'xxgs',
          params: {
            nr: key
          }
        }
      }
    }, [_vm._v(_vm._s(item) + "\n    ")]) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    class: {
      zz: _vm.showOthers
    }
  }, [_c('div', {
    staticClass: "zzc"
  }), _vm._v(" "), _c(_vm.$route.params.nr, {
    tag: "component",
    staticClass: "wrapper min-height"
  })], 1), _vm._v(" "), _c('ICP')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("信息公示")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b430145"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/xxgs/xxgs.vue
// module id = 807
// module chunks = 2